// actions.js

export const setData = (data) => ({
  type: "SET_DATA",
  payload: data,
});

export const setPermissions = (permissions) => ({
  type: "SET_PERMISSIONS",
  payload: permissions,
});


export const setSessionData = (data) => ({
  type: "SESSION_DATA",
  payload: data,
});

export const setLanguage = (language, direction) => ({
  type: "SET_LANGUAGE",
  payload: { language, direction },
});
